import React, { useState, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { reduxForm } from "redux-form";
import { FAQ, PAGE_LIMIT } from "helpers/viewContent";
import ReactPagination from "components/shared/ReactPagination";
import { FORMAT_TEXT } from "helpers/common";
import { DELETE_ALERT } from "helpers/constantsMessage";
import ContentLoader_ from "helpers/ContentLoader_";

//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
import { getFAQ_, deleteFAQ_, updateStatusFAQ_ } from "store/services/faqService";

const Listing = ({ dispatch, itemsCountPerPage, totalItemsCount }) => {
  //pagination
  const [activePage, setActivePage] = useState(1);
  const [isLoading, setIsLoading] = useState(false);

  const [filter, setFilter] = useState({
    page: activePage,
    limit: PAGE_LIMIT,
  });

  const [listing, setListing] = useState([]);
  async function getData() {
    try {
      let query = {
        ...filter,
      };
      setIsLoading(true);
      dispatch(actions.persist_store({ loader: false }));
      let res = await dispatch(getFAQ_(query));
      setListing(res?.body?.data);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  }
  useEffect(() => {
    getData();
  }, [filter?.page]);

  //pagination
  const handlePageChange = (page) => {
      setActivePage(page);

    setFilter({
      ...filter,
      page: page,
    });
    window.scrollTo(0, 0);
  };

  //delete
  const deleteFAQData_ = async (id) => {
    try {
      await DELETE_ALERT().then(async (willDelete) => {
        if (willDelete) {
          try {
            let query = {
              id: id,
            };
            await dispatch(deleteFAQ_(query)).then(() => {
              getData();
            });
          } catch (err) {
            console.log(err);
          }
        }
      });
    } catch (err) {
      console.log(err);
      dispatch(actions.persist_store({ loader: false }));
    }
  };
  //update status
  const updateStatus_ = async (id) => {
    try {
      let query = {
        id: id,
      };
      await dispatch(updateStatusFAQ_(query));
      getData();
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      <Helmet title={FAQ.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-format-list-bulleted menu-icon"></i>
          </span>{" "}
          {FAQ.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.faq}>{FAQ.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              Listing
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-lg-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">
                <div className="row">
                  <div className="col-md-6">Listing</div>
                  <div className="col-md-4"></div>
                  <div className="col-md-2">
                    <Link to={Path.faq_form} title="Add">
                      <button type="button" class="btn btn-lg btn-gradient-primary">
                        {" "}
                        + Add
                      </button>
                    </Link>
                  </div>
                </div>
              </h4>
              <div class="table-responsive actionSticky">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th> Question </th>
                      <th> Answer </th>
                      <th> Order </th>
                      <th> type </th>
                      <th> Action </th>
                    </tr>
                  </thead>
                  {isLoading ? (
                    <div className="loader-class">
                      <ContentLoader_ />
                    </div>
                  ) : (
                    <tbody>
                      {listing?.length > 0 &&
                        listing.map((list, i) => {
                          return (
                            <tr key={i}>
                              <td className="py-1">
                                {list?.question ? FORMAT_TEXT(list?.question) : "---"}
                              </td>
                              <td className="py-1">
                                <div
                                  dangerouslySetInnerHTML={{
                                    __html: list?.answer ? FORMAT_TEXT(list?.answer) : "---",
                                  }}
                                />
                              </td>

                              <td className="py-1">
                                {list?.order?.toString()}
                              </td>
                              <td className="py-1">
                                {Number(list?.type) === 1 ? "Player" : "Coach"}
                              </td>
                              {/* <td onClick={() => updateStatus_(list?.id)}>
                                <label
                                  style={{ cursor: "pointer" }}
                                  className={`badge badge-gradient-${list?.status == 1 ? "success" : "danger"
                                    }`}
                                >
                                  {list?.status == 1 ? "Active" : "Inactive"}
                                </label>
                              </td> */}
                              <td>
                                <Link to={`${Path.faq_form}/${list?.id}`}>
                                  <label
                                    class="btn btn-sm btn btn-gradient-warning"
                                    style={{ cursor: "pointer" }}
                                    title="Edit"
                                  >
                                    <i className="mdi mdi-grease-pencil"></i>
                                  </label>
                                </Link>
                                &nbsp;&nbsp;
                                <label
                                  className="btn btn-sm btn btn-gradient-danger"
                                  style={{ cursor: "pointer" }}
                                  title="Delete"
                                  onClick={() => deleteFAQData_(list?.id)}
                                >
                                  <i className="mdi mdi-delete"></i>
                                </label>
                              </td>
                            </tr>
                          );
                        })}
                    </tbody>
                  )}
                </table>
              </div>
              {listing.length > 0 && (
                <div className="pagination-box-review">
                  <ReactPagination
                    activePage={filter?.page}
                    itemsCountPerPage={itemsCountPerPage}
                    totalItemsCount={totalItemsCount}
                    handlePageChange={handlePageChange}
                  />
                </div>
              )}
              {!isLoading && listing.length == 0 && (
                <div className="row">
                  <div className="col-md-6 pt-5">
                    <span>No data found...</span>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const mapStateToPros = (state) => {
  return {
    itemsCountPerPage: state.Faq.itemsCountPerPage,
    totalItemsCount: state.Faq.totalItemsCount,
    loader: state.Faq.loader,
  };
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(Listing);
